import * as React from "react";

//@ts-ignore
import utsStoreLogo from "../images/uts-store.png";

const { Component } = React;

import { Input, Row, Col, Label, Modal, ModalHeader, ModalBody, ModalFooter, Button, Tooltip, Alert, Container } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OrganizationContextSwitcher from "../organizations/ContextSwitcher";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";
import * as AccountStore from "../account/AccountStore";
import { Link } from "react-router-dom";
import * as ApplicationsStore from "../applications/ApplicationsStore";
import { ApplicationCard } from "../general/ApplicationCard";

let contextSubscriptionId = "";

let now = new Date();

let timeOfDay = now.getHours() < 12 ? "Morning" : now.getHours() < 18 ? "Afternoon" : "Evening";

interface HomeState {
    isLoading: boolean;
    organizationId: string;
    currentUser: any;
    apps: Array<any>;
    showDisabledTooltip: boolean;
}

export default class HomeIndex extends Component<any, HomeState> {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            organizationId: "",
            currentUser: {},
            apps: [],
            showDisabledTooltip: false,
        };
    }

    componentDidMount() {
        AccountStore.GetCurrentLoggedInUser().then((user) => {
            this.setState({ currentUser: user, isLoading: false });
        });

        contextSubscriptionId = GetContext((context) => {
            this.setState({ organizationId: context.currentOrganization.id });

            this.loadApps();
        });
    }

    loadApps = () => {
        this.setState({ apps: [] });
        ApplicationsStore.LoadMyApps().then((response) => {
            this.setState({
                apps: response,
            });
        });
    };

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    toggleDisabledTooltip = () => {
        this.setState((prevState) => ({ showDisabledTooltip: !prevState.showDisabledTooltip }));
    };

    render() {
        return (
            <div>
                {!this.state.isLoading && (
                    <>
                        <OrganizationContextSwitcher></OrganizationContextSwitcher>

                        <div className="container">
                            <h1 className="text-center">
                                Good {timeOfDay} {this.state.currentUser.firstName || this.state.currentUser.fullName}
                            </h1>

                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, 350px)", gap: "2rem", justifyContent: "center", paddingTop: "2rem" }}>
                                {this.state.apps.map((app, i) => (
                                    <ApplicationCard key={i} app={app}></ApplicationCard>
                                ))}
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    }
}
